"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var storybook_1 = require("@eyecons/storybook");
var ra_fetch_1 = require("ra-fetch");
var prop_types_1 = __importDefault(require("prop-types"));
function CardsTrack(_a) {
    var setModal = _a.setModal, modalClose = _a.modalClose, mediaId = _a.mediaId, pointerTime = _a.pointerTime, seconds = _a.seconds, setSubmitting = _a.setSubmitting, videoLength = _a.videoLength, createCard = _a.createCard, setCreateCard = _a.setCreateCard;
    var _b = ra_fetch_1.useApi('media').index('video_cards', {
        external_id: mediaId,
    }), cards = _b[0], setCards = _b[1];
    var calculateX = function (card, seconds) {
        return (card.start_seconds / seconds) * 100;
    };
    if (cards.loading) {
        return react_1.default.createElement("div", null, "Loading");
    }
    if (createCard) {
        cardClick();
        setCreateCard(false);
    }
    // Get clickedCard and open modal
    function cardClick(card) {
        setModal({
            content: function () { return react_1.default.createElement(storybook_1.Timelines.AddCard, { cards: cards, setCards: setCards, clickedCard: card, mediaId: mediaId, modalClose: modalClose, setModal: setModal, pointerTime: pointerTime, setSubmitting: setSubmitting, videoLength: videoLength }); },
        });
    }
    return react_1.default.createElement("div", { className: 'storybook-timelines-cards-track', title: 'Klik in het vlak om de tijdlijn te verschuiven' }, cards.data.map(function (card, index) {
        return react_1.default.createElement(storybook_1.Timelines.Card, { card: card, key: index, onClick: (function (event) {
                event.stopPropagation();
                cardClick(card);
            }), style: calculateX(card, seconds) + '%' });
    }));
}
exports.default = CardsTrack;
CardsTrack.propTypes = {
    mediaId: prop_types_1.default.string.isRequired,
    seconds: prop_types_1.default.number,
};
